import script from "./editRule.vue?vue&type=script&setup=true&lang=js"
export * from "./editRule.vue?vue&type=script&setup=true&lang=js"

import "./editRule.vue?vue&type=style&index=0&id=db2bf486&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db2bf486"]])

export default __exports__